import React, { Component } from 'react';
import {Spinner, Row, Col, Button } from 'react-bootstrap';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import {ClidReportGenerate, resetReport, ClidReportDownload, closeModalPopUp} from './ReportsActions';
import { connect } from 'react-redux';	
import ShowModalPopUp from '../ShowModalPopUp';
import DatePicker from "react-datepicker";
import moment from "moment";
import ReportViewQAP from './ReportViewQAP';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import {URL_API_REPORTS_QAP_AUDIT_REPORT_GENERATE, URL_API_REPORTS_QAP_AUDIT_REPORT_EXCEL} from '../apiHitFile'
import _ from 'lodash';

 class QAPAudits extends Component { 
  constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      saveClicked:false,
      GenerateReport:false,
      toggleA:true
    }
   }
  componentDidMount(){    
    this.props.actioninventoryUserMapped()
    this.props.resetReport()
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
    }    
  }

  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
     let regionNames = _.filter(inventory);
      return regionNames;
    }    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){
      let centerName = selectedregionName.userCenters
      return centerName;
    }
    
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    let clientName = []
    if(!_.isEmpty(selectedcenterName)){
        clientName = _.filter(selectedcenterName.userClients);
        clientName = _.uniqBy(clientName, 'inventoryClientId');
    }
    return clientName;
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    let processName=[];
    if(!_.isEmpty(selectedclientName)){
            processName = (selectedclientName.userProcesses)
            processName = _.uniqBy(processName, 'inventoryProcessId');
      }
    return processName;
  }  
  
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[]})
      this.generateFalse()
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.generateFalse()
      this.setState({selectedclientName:[], selectedprocessName:[]})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.generateFalse()
      this.setState({selectedprocessName:[]})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
    if(!_.isEqual(this.state.selectedprocessName, e)){
      this.generateFalse()
    }
  }
  handleChangeStart = (date) => {
    this.setState({startDate: date});
    if(!_.isEqual(this.state.startDate, date)){
      this.generateFalse()
    }
  }
  validateInput = () =>{
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate} = this.state
    if(!_.isEmpty(selectedregionName) && !_.isEmpty(selectedcenterName) && !_.isEmpty(selectedclientName) &&
    !_.isEmpty(selectedprocessName) && typeof startDate !== "undefined"){
      return true
    }
  }   
  generateReport = () => {
    const {selectedregionName, selectedcenterName, selectedclientName,selectedprocessName, startDate} = this.state
    let obj = {
      "regionId":selectedregionName.inventoryRegionId,
      "centerId":selectedcenterName.inventoryCenterId,
      "clientId":selectedclientName.inventoryClientId,
      "processId":selectedprocessName.inventoryProcessId,
      "region":selectedregionName.inventoryRegionName,
      "center":selectedcenterName.inventoryCenterName,
      "client":selectedclientName.inventoryClientName,
      "process":selectedprocessName.inventoryProcessName,
      "month":moment(startDate).format('MMM'),
      "year":moment(startDate).format('YYYY')
      }
    this.props.TokenValidation()
    this.props.ClidReportGenerate(obj, URL_API_REPORTS_QAP_AUDIT_REPORT_GENERATE)
    this.setState({GenerateReport:true})
    //this.setState({GenerateReport:true}, ()=>this.handleToggle())
  }
  generateFalse = () =>{
    this.setState({GenerateReport:false})
  }
  handleToggle = () =>{
    this.setState((prevState) =>{
      return {toggleA: !prevState.toggleA};
    })
  }
  downloadReport= () =>{
    const {selectedregionName, selectedcenterName, selectedclientName,selectedprocessName, startDate} = this.state
    let obj = {
      "regionId":selectedregionName.inventoryRegionId,
      "centerId":selectedcenterName.inventoryCenterId,
      "clientId":selectedclientName.inventoryClientId,
      "processId":selectedprocessName.inventoryProcessId,
      "region":selectedregionName.inventoryRegionName,
      "center":selectedcenterName.inventoryCenterName,
      "client":selectedclientName.inventoryClientName,
      "process":selectedprocessName.inventoryProcessName,
      "month":moment(startDate).format('MMM'),
      "year":moment(startDate).format('YYYY')
      }
     this.props.TokenValidation()
     this.props.ClidReportDownload(obj, URL_API_REPORTS_QAP_AUDIT_REPORT_EXCEL, "QAP_AUDIT_REPORTS.xlsx")
   }


	render(){
    const {GenerateReport, toggleA} = this.state; 
    console.log('this',this.props.reportData)
		let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
        }		
		return(
			<div  className={(style) ? 'user' : "userSmall"}>			
				{(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
        {this.props.isPending === true ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}
        <div>
          <h6 onClick={this.handleToggle} >
          {toggleA ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>&nbsp;REPORT CRITERIA</b></h6>  
        <div className={toggleA ? '': 'assesmentHide'}>  
          <Row className="marginBottom">  
          <Col>
          <label><b>REGION NAME<span className="RedColoring"> *</span></b></label><br/>
          <Picky keepOpen={false}
          value={this.state.selectedregionName}
          options={this.regionNames()}
          onChange={this.handleSelect}
          open={false}
          valueKey="inventoryRegionName"
          labelKey="inventoryRegionName"
          multiple={false}
          includeSelectAll={false}
          includeFilter={false}
          placeholder='Select Region'
          dropdownHeight={600}
          />
          </Col>
          <Col>
          <label><b>CENTER NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectedcenterName}
          options={this.centerNames()}
          onChange={this.handleSelectCenter}
          open={false}
          valueKey="inventoryCenterName"
          labelKey="inventoryCenterName"
          multiple={false}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Center'
          dropdownHeight={600}
          />
          </Col>
          <Col>
          <label><b>CLIENT NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectedclientName}
          options={this.clientNames()}
          onChange={this.handleSelectClient}
          open={false}
          valueKey="inventoryClientName"
          labelKey="inventoryClientName"
          multiple={false}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Client'
          dropdownHeight={600}
          />
          </Col>        
          <Col> 
            <label><b>PROCESS NAME<span className="RedColoring"> *</span></b></label>
            <Picky keepOpen={false}
            value={this.state.selectedprocessName}
            options={this.processNames()}
            onChange={this.handleSelectProcess}
            open={false}
            valueKey="inventoryProcessName"
            labelKey="inventoryProcessName"
            multiple={false}
            includeSelectAll={true}
            includeFilter={false}
            placeholder='Select Process'
            dropdownHeight={600}
          /></Col>
          <Col>
          <label><b>DATE<span className="RedColoring"> *</span></b></label>
          <DatePicker
          selected={this.state.startDate}
          onChange={this.handleChangeStart}
          dateFormat="MM/yyyy"
          showMonthYearPicker
          placeholderText="Select Month/Year"
          />
          </Col>       
          </Row> 
       </div>
          <Button className='buttonwidth alignInline alignRight' disabled={!this.validateInput()}
            onClick={this.generateReport}>Generate Report</Button>
          {((GenerateReport === true) && !_.isEmpty(this.props.reportData)  && !_.isEmpty(this.props.reportData.value)) ?
          <Button className='buttonwidth alignInline alignRight' onClick={this.downloadReport}>Download Report</Button> 
          : null} 
          {((GenerateReport === true) && !_.isEmpty(this.props.reportData)) ?
            <div>
           <ReportViewQAP  reportData={this.props.reportData}/> 
           </div>
          : null }
        </div> 
        </div>)
	}

}
function mapStateToProps(state){
  return{
    size: state.UserReducer.large,    
    inventory: state.UserReducer.inventoryMapped, 
    reportData: state.ReportsReducer.reportData, 
    isPending: state.ReportsReducer.isPending,
    showerror:  state.ReportsReducer.showerror, 
    errmessage:  state.ReportsReducer.errmessage,
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  ClidReportGenerate: (a, b) => dispatch(ClidReportGenerate(a,b)),
  ClidReportDownload: (a, b, c) => dispatch(ClidReportDownload(a, b, c)),
  resetReport: () => dispatch(resetReport()),
  TokenValidation : () => dispatch(TokenValidation()),
  closeModalPopUp:  () =>dispatch(closeModalPopUp()), 
  
})


export default connect(mapStateToProps, mapDispatchToProps)(QAPAudits);     